export const FineFoodsIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
    props,
) => (
    <img
                    style={{ marginBottom: -22 }}
                    src="/images/lockdown.png"
                    alt="Logo"
                    width="100%"
                />
);
